export default __webpack_public_path__ + "pinterest.png";